import { UseFormReturn } from "react-hook-form";
import { ModuleStatuses, ModuleTypeFamily, ModuleTypeId } from "../../types/DBTables";

import TextEditor from "../Global/Editors/TextEditor";
import { useGlobalData } from "../GlobalDataProvider";
import { DTOBuilding, DTOModule } from "../../types/building";
import { Button, Card, Table } from "react-bootstrap";
import NumberEditor from "../Global/Editors/NumberEditor";
import { IModuleVentilationFTXochFTConfig, IModuleVärmeElConfig } from "../../types/ModuleDatas";
import { nameof } from "../Global/Utils";
import WizardModuleTable, { WizardModuleTableStyles } from "./WizardModuleTable";

interface IProps {
  building: DTOBuilding;
  formHook: UseFormReturn;
  onAddModule: (mt: ModuleTypeId) => void;
  onRemoveModule: (mId: Number) => void;
}

const WizardPage3 = ({ building, formHook, onAddModule, onRemoveModule }: IProps) => {
  const globalData = useGlobalData();

  const ventilationFxModules = building.modules.filter((m) => m.moduleTypeId === ModuleTypeId.VentilationFX);
  const integratedPumps = ventilationFxModules.reduce((acc: DTOModule[], mod: DTOModule) => {
    let mNew = {
      moduleTypeId: ModuleTypeId.VarmePrimarPump,
      name: mod.name + " Integrerad värmepump",
      data: "{}",
      status: ModuleStatuses.Configured,
      id: -(mod.id + 100),
    } as DTOModule;
    acc.push(mNew);
    return acc;
  }, [] as DTOModule[]);

  const ventLuftburenModules = building.modules.filter((m) => m.moduleTypeId === ModuleTypeId.VentilationFTX || m.moduleTypeId === ModuleTypeId.VentilationFT);
  const luftburenVentilations = ventLuftburenModules.reduce((acc: DTOModule[], mod: DTOModule) => {
    const modData = JSON.parse(mod.data) as IModuleVentilationFTXochFTConfig;
    const isLuftburen = modData.ärHuvudsakligtVärmesystem === "Ja";
    if (!isLuftburen) return acc;
    let mNew = {
      moduleTypeId: ModuleTypeId.VarmePrimarAnnatSystem,
      name: mod.name + " Luftburen värme",
      data: "{}",
      status: ModuleStatuses.Configured,
      id: -(mod.id + 100),
    } as DTOModule;
    acc.push(mNew);
    return acc;
  }, [] as DTOModule[]);
  const staticModules = integratedPumps.concat(luftburenVentilations);

  const heatModuleTypesPrimaryNormal = globalData.moduleTypes.filter(
    (mt) => mt.family === ModuleTypeFamily.VärmePrimar && !(mt.id === ModuleTypeId.VarmePrimarSaknas || mt.id === ModuleTypeId.VarmePrimarAnnatSystem)
  );
  let heatModuleTypesPrimary = heatModuleTypesPrimaryNormal
    .concat(globalData.moduleTypes.filter((mt) => mt.id === ModuleTypeId.VarmePrimarAnnatSystem))
    .concat(globalData.moduleTypes.filter((mt) => mt.id === ModuleTypeId.VarmePrimarSaknas));

  const heatModulesPrimary = building.modules.filter((m) => heatModuleTypesPrimary.find((mt) => mt.id === m.moduleTypeId));
  if (staticModules.length > 0 || (heatModulesPrimary.length > 0 && heatModulesPrimary.find((m) => m.moduleTypeId === ModuleTypeId.VarmePrimarSaknas)) === undefined) {
    heatModuleTypesPrimary = heatModuleTypesPrimary.filter((mt) => mt.id !== ModuleTypeId.VarmePrimarSaknas);
  }

  const heatModuleTypesSecondarySecondary = globalData.moduleTypes.filter((mt) => mt.family === ModuleTypeFamily.VärmeSekundar && mt.id !== ModuleTypeId.VarmeSekundarSaknas);
  const heatModuleTypesSecondaryEl = globalData.moduleTypes.filter((mt) => mt.family === ModuleTypeFamily.VärmeEl);
  let heatModuleTypesSecondary = heatModuleTypesSecondarySecondary
    .concat(heatModuleTypesSecondaryEl)
    .concat(globalData.moduleTypes.filter((mt) => mt.id === ModuleTypeId.VarmeSekundarSaknas));

  const heatModulesSecondary = building.modules.filter((m) => heatModuleTypesSecondary.find((mt) => mt.id === m.moduleTypeId));
  if (heatModulesSecondary.length > 0 && heatModulesSecondary.find((m) => m.moduleTypeId === ModuleTypeId.VarmeSekundarSaknas) === undefined) {
    heatModuleTypesSecondary = heatModuleTypesSecondary.filter((mt) => mt.id !== ModuleTypeId.VarmeSekundarSaknas);
  }

  const totalUsage = heatModulesSecondary.reduce((acc, m) => {
    const modData = JSON.parse(m.data) as IModuleVärmeElConfig;
    const andel = modData.värmeSystemandel as number;
    return acc + andel;
  }, 0);

  return (
    <>
      {/* PrimärVärme */}
      <Card.Title className="pt-4">Primärvärme</Card.Title>
      <WizardModuleTable
        modules={heatModulesPrimary}
        moduleTypes={heatModuleTypesPrimary}
        tableStyle={WizardModuleTableStyles.Normal}
        onRemoveModule={onRemoveModule}
        onAddModule={onAddModule}
        formHook={formHook}
        staticModules={staticModules}
      />
      <Card.Title className="pt-4">Sekundärvärme och direktverkande elsystem</Card.Title>
      <WizardModuleTable
        modules={heatModulesSecondary}
        moduleTypes={heatModuleTypesSecondary}
        tableStyle={WizardModuleTableStyles.HeatSecondary}
        onRemoveModule={onRemoveModule}
        onAddModule={onAddModule}
        formHook={formHook}
      />
    </>
  );
};

export default WizardPage3;
